import request from '@/utils/request';

export function getShopProductList(query) {
  return request({
    url: '/api/system/shopProduct/queryEnableShopProductList',
    method: 'post',
    data: query
  });
}

export function saveShopProduct(form) {
  return request({
    url: '/api/system/shopProduct/saveShopProduct',
    method: 'post',
    data: form
  });
}

export function getShopCategoryList(query) {
  return request({
    url: '/api/system/shopCategory/getShopCategoryList',
    method: 'post',
    data: query
  });
}

export function getShopProductPage(query) {
  return request({
    url: '/api/system/shopProduct/queryShopProductPage',
    method: 'post',
    data: query
  });
}

export function getShopCategoryProdList(query) {
  return request({
    url: '/api/system/shopProduct/getShopCategoryProdList',
    method: 'post',
    data: query
  });
}

export function getShopProduct(query) {
  return request({
    url: '/api/system/shopProduct/getShopProduct',
    method: 'post',
    data: query
  });
}

//促销商品
export function getProductCpModuleGood(query) {
  return request({
    url: '/api/system/shopModuleGood/getProductCpModuleGood',
    method: 'post',
    data: query
  });
}
//查询价格区间
export function queryShopSectionList(query) {
  return request({
    url: '/api/system/shopSection/queryShopSectionList',
    method: 'post',
    data: query
  });
}
//库存颜色
export function querysysProductStockList(query) {
  return request({
    url: '/api/system/sysProductStock/querysysProductStockList',
    method: 'post',
    data: query
  });
}
//
export function queryShopSkuList(query) {
  return request({
    url: '/api/system/shopSku/queryShopSkuList',
    method: 'post',
    data: query
  });
}
export function getByShopProduct(query) {
  return request({
    url: '/api/system/shopProduct/getByShopProduct',
    method: 'post',
    data: query
  });
}
export function queryShopProductPage(query) {
  return request({
    url: '/api/system/shopProduct/queryShopProductPage',
    method: 'post',
    data: query
  });
}
export function getSearchLog(query) {
  return request({
    url: '/api/system/shopProduct/getSearchLog',
    method: 'post',
    data: query
  });
}
export function getElectron(query) {
  return request({
    url: '/api/system/shopProduct/getElectron',
    method: 'post',
    data: query
  })
}
//轮播图关联的商品
export function getBannerGoodList(query) {
  return request({
    url: '/api/system/sysBannerGood/getBannerGoodList',
    method: 'post',
    data: query
  })
}
//快捷菜单关联的商品
export function getNavGoodList(query) {
  return request({
    url: '/api/system/sysNavGood/getNavGoodList',
    method: 'post',
    data: query
  })
}
// 根据分类查询商品
export function getCategoryProductList(query) {
  return request({
    url: '/api/system/shopProduct/getCategoryProductList',
    method: 'post',
    data: query
  })
}
//购物车推荐
export function getCartRecommend(query) {
  return request({
    url: '/api/system/shopProduct/getCartRecommend',
    method: 'post',
    data: query
  })
}
//推荐商品
export function getNewProductList(query) {
  return request({
    url: '/api/system/shopProduct/getNewProductList',
    method: 'post',
    data: query
  })
}
//推荐商品
export function queryRecommendProduct(query) {
  return request({
    url: '/api/system/shopProduct/queryRecommendProduct',
    method: 'post',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/product/index.js